export default __webpack_public_path__ + "static/media/3.5c4b3671.png";